export default function formatSearchTerm(searchTerm) {
  return searchTerm?.replaceAll('+', ' ')
}
